export default __webpack_public_path__ + "static/media/blog-3.30442a96.jpg";